// 导入 request.ts 文件
import request from "@/utils/request/request";

// 查询产品列表
// 定义一个函数，接收一个 IProductQuery 类型的参数并打印信息
/**
 *   (query: IProductQuery)    是前端给后端的数据的类型约束
 *   : Promise<IResponseData<IProductRes>>   是后端给前端的数据的类型约束
 *      因为后端返回的一定是一个Promise，查看源码可以看到Promise是一个接口，并且自带了泛型，所以，需要写  :Promise<T>
 */
export function listProduct(
  query: IProductQuery
): Promise<IResponseData<IProductRes>> {
  return request({
    url: "/system/product/list",
    method: "get",
    params: query,
  });
}

// 查询解决方案列表
export function listSolution(
  query: IServiceQuery
): Promise<IResponseData<IServiceRes>> {
  return request({
    url: "/system/solution/list",
    method: "get",
    params: query,
  });
}

// 查询新闻列表
export function listNews(query: INewsQuery): Promise<IResponseData<INewsRes>> {
  return request({
    url: "/system/news/list",
    method: "get",
    params: query,
  });
}

// 查询大事记列表
export function listEvent(
  query: IEventQuery
): Promise<IResponseData<IEventRes>> {
  return request({
    url: "/system/event/list",
    method: "get",
    params: query,
  });
}
